import { styled } from '@uhg-abyss/web/tools/styled';
import { Medium, Regular, SemiBold } from '../../apps/styles/common-style';

export const ErrorCardNewStyle = styled.div({
    ".container": {
        width: '960px',
        // height: '59px',
        backgroundColor: '#ffffff',
        borderRadius: '2px 0px 0px 0px',
        border: '1px solid #196ECF'
    },
    '.grey-line': {
        width: '960px',
        height: '0',
        margin: '0'
    },
    ".message-text": {
        lineHeight: '18px',
        fontSize: '16px',
        letterSpacing: '0.2px',
        paddingLeft: '4px'
    },
    ".error-message": {
        display: 'flex',
        alignitems: 'center',
        padding: '7px'
    },
    ".info-message": {
        display: 'flex',
        padding: '10px 14px 10px 14px'
    },
    ".bold-message": {
        fontFamily: SemiBold,
    },
    ".message": {
        fontFamily: Regular,
    },
    ".icon": {
        // textAlign: 'center',
        // paddingTop: '56px'
        paddingRight: '8px'
    },

    ".title": {
        color: '#2d2d39',
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '22px',
        textAlign: 'center'
    },

    ".description": {
        color: '#2d2d39',
        fontWeight: '500',
        fontSize: '16px',
        textAlign: 'center',
        letterSpacing: '0.2px',
        lineHeight: '22px'
    },
    ".greyLine": {
        border: '1px solid #E0E0E0'
    },
    ".box": {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        border: '1px solid #196ECF'
    },
    ".abyss-card-root": {
        borderWidth: '0px !important'
    },
    ".tax-info-message": {
        width: '478px',
        height: '62px',
        margin: '10px',
        border: '1px solid #CBCCCD',
        boxSizing: 'border-box',
        display: 'flex'
    },
      ".tax-info-message-fallback": {
        width: '960px',
        height: '62px',
        margin: '10px',
        border: '1px solid #CBCCCD',
        boxSizing: 'border-box',
        display: 'flex'
    },
    ".message-text-tax": {
        display: 'flex',
        padding: '7px',
        paddinLeft: '0px',
        fontFamily: Medium,
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '100%',
        letterSpacing: '0px'
    },
    ".error-icon-tax": {
        padding: '10px',
        paddingRight: '0px'
    },
    ".error-tax": {
        fontWeight: '600'
    }



})